(function () {
  'use strict';

  function initBlog(root) {
    if (!root || root.getAttribute('data-nb-initialized')) return;
    root.setAttribute('data-nb-initialized', 'true');

    var revealEls = root.querySelectorAll('.nb-reveal:not(.nb-in)');
    if (!revealEls.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('nb-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el, i) {
        el.style.transitionDelay = Math.min(i % 6, 5) * 0.06 + 's';
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) { el.classList.add('nb-in'); });
    }

    // keep the active tag chip scrolled into view on small screens
    var activeTag = root.querySelector('.nb-tag--active');
    var tagsRow = root.querySelector('.nb-tags');
    if (activeTag && tagsRow) {
      var offset = activeTag.offsetLeft - tagsRow.clientWidth / 2 + activeTag.clientWidth / 2;
      tagsRow.scrollLeft = Math.max(0, offset);
    }
  }

  function boot() {
    document.querySelectorAll('.naseebo-blog').forEach(initBlog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.naseebo-blog');
    if (root) initBlog(root);
  });
})();